import { Box, Typography } from "@mui/material";

function DottedTitleDivider({ title, ...props }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }} {...props}>
      <Box
        sx={{
          flex: 1,
          borderTop: (theme) => `1px dotted ${theme.palette.grey[4]}`,
        }}
      ></Box>
      <Typography mx={1} variant="h5" color="grey.3">
        {title}
      </Typography>
      <Box
        sx={{
          flex: 1,
          borderTop: (theme) => `1px dotted ${theme.palette.grey[4]}`,
        }}
      ></Box>
    </Box>
  );
}

export default DottedTitleDivider;
